import {
  compose,
  withHandlers,
  withProps,
  withPropsOnChange,
  withState,
} from 'recompose';
import { map, merge, pick, pipe, reduce, symmetricDifference } from 'ramda';
import sumBy from 'lodash/fp/sumBy';
import find from 'lodash/fp/find';
import reject from 'lodash/fp/reject';
import groupBy from 'lodash/fp/groupBy';
import { preparePayments } from '../../../register/payment/reducer/payments/actions';
import SplitPayment from '../components/SplitPayment';

const transformPayments = pipe(
  groupBy('id'),
  Object.values,
  map(pipe(
    reduce(merge, {}),
    pick(['id', 'amount', 'tipAmount']),
  )),
);

const SplitPaymentContainer = compose(
  withProps(props => ({
    payments: preparePayments(props.item.payments),
  })),
  withState('selectedPayments', 'setSelectedPayments', []),
  withState('selectedTips', 'setSelectedTips', []),
  withState('refundAmount', 'setRefundAmount', 0),
  withState('selectedPayment', 'setSelectedPayment', null),
  withHandlers({
    togglePayment: props => item => () => {
      if (find({ id: item.id }, props.selectedPayments)) {
        const payments = reject({ id: item.id }, props.selectedPayments);
        props.setSelectedPayments(payments);
      } else {
        props.setSelectedPayment(item);
      }
    },
    onSelectedSubmit: props => (amount) => {
      props.setSelectedPayments([
        ...props.selectedPayments,
        { ...props.selectedPayment, amount },
      ]);
      props.setSelectedPayment(null);
    },

    toggleTip: props => item => () => {
      const tipItem = { id: item.id, tipAmount: item.tip, type: 'tip' };
      const selectedTips = symmetricDifference([tipItem], props.selectedTips);
      props.setSelectedTips(selectedTips);
    },

    refund: props => () => {
      props.refund(
        props.item,
        { payments: transformPayments([...props.selectedPayments, ...props.selectedTips]) }
      );
    },

    closeSelectedPayment: props => () => props.setSelectedPayment(null),
  }),
  withPropsOnChange(
    ['selectedPayments', 'selectedTips'],
    (props) => {
      props.setRefundAmount(
        sumBy('amount', props.selectedPayments) + sumBy('tipAmount', props.selectedTips),
      );
      if (props.selectedPayments.length || props.selectedTips.length) {
        props.refund();
      }
    }
  ),
);

export default SplitPaymentContainer(SplitPayment);
